<template>
  <vxe-modal
      v-model="createSalesmanModal"
      :title="modalTitle"
      width="1200"
      height="680"
      resize
      destroy-on-close
      @close="close"
      remember
  >
    <div class="modal-container">
      <vxe-form
          ref="xForm"
          class="my-form3"
          title-align="right"
          title-width="110"
          :data="formData"
          style="height: 100%"
          :rules="formRules"
          @submit="commit"
      >
        <vxe-form-item
            title="业务员:"
            field="salesManId"
            :title-width="80"
            span="6"
            title-align="left"
        >
          <Select v-model="formData.salesManId" filterable :disabled="isDdit">
            <Option
                v-for="item in salesmanList"
                :value="item.value"
                :key="item.value"
            >{{ item.label }}
            </Option>
          </Select>
        </vxe-form-item>
        <vxe-form-item
            title="客户经理:"
            field="clientManagerId"
            :title-width="85"
            style="padding-right: 10px"
            span="6"
            title-align="left"
        >
          <Select v-model="formData.clientManagerId" clearable filterable>
            <Option
                v-for="item in salesManageList"
                :value="item.value"
                :key="item.value"
            >{{ item.label }}
            </Option>
          </Select>
        </vxe-form-item>
        <vxe-form-item
            span="6"
            title="销售经理:"
            field="salesManagerId"
            :title-width="80"
            title-align="left"
        >
          <Select v-model="formData.salesManagerId" clearable filterable>
            <Option
                v-for="item in salesManageList"
                :value="item.value"
                :key="item.value"
            >{{ item.label }}
            </Option>
          </Select>
        </vxe-form-item>
        <vxe-form-item
            span="6"
            title="外部销售:"
            field="salesManagerIdOutside"
            :title-width="80"
            title-align="left"
        >
          <Select v-model="formData.salesManagerIdOutside" clearable filterable>
            <Option
                v-for="item in salesManageList"
                :value="item.value"
                :key="item.value"
            >{{ item.label }}
            </Option>
          </Select>
        </vxe-form-item>
        <vxe-form-item
            span="6"
            title="提成:"
            field="salesManagerId"
            :title-width="80"
            title-align="left"
        >
          <Select v-model="formData.isCps" filterable>
            <Option value="1">是</Option>
            <Option value="0">否</Option>
          </Select>
        </vxe-form-item>
        <vxe-form-item
            span="6"
            title="内部提成(%):"
            field="salesManagerId"
            :title-width="100"
            title-align="left"
        >
          <vxe-input
              v-model="rateCps"
              placeholder="选填"
              @input="file => checkNum(file,'rateCps')"
          ></vxe-input>
        </vxe-form-item>
        <vxe-form-item
            span="6"
            title="外部提成(%):"
            field="salesManagerId"
            :title-width="100"
            title-align="left"
        >
          <vxe-input
              v-model="rateCpsOutside"
              placeholder="选填"
              @input="file => checkNum(file,'rateCpsOutside')"
          ></vxe-input>
        </vxe-form-item>
        <vxe-form-item
            span="6"
            title="提成设置:"
            field="salesManagerId"
            :title-width="80"
            title-align="left"
        >
          <Select v-model="formData.cpsType" clearable>
            <Option :value="1">销项仅统计水运</Option>
            <Option :value="2">销项仅统计汽运</Option>
          </Select>
        </vxe-form-item>
        <vxe-form-item
            span="6"
            title="签约:"
            field="salesManagerId"
            :title-width="80"
            title-align="left"
        >
          <div style="display: flex;align-items: center;">
            <Select v-model="formData.isSign" filterable>
              <Option
                  v-for="item in isSignList"
                  :value="item.value"
                  :key="item.value"
              >{{ item.label }}
              </Option>
            </Select>
            <Button
                v-if="!contractNum"
                type="primary"
                icon="ios-add"
                @click="openContract"
                style="margin-left: 10px;height: 26px;border-radius: 4px;display: flex;align-items: center;"
            >
              选择合同
            </Button>
            <div v-else style="display: flex;align-items: center">
              {{ contractNum }}
              <Icon
                  type="ios-close-circle"
                  size="16"
                  color="#c0c3cb"
                  @click.native="remove()"
              ></Icon>
            </div>
          </div>
        </vxe-form-item>
        <vxe-form-item span="18"></vxe-form-item>
        <span
            class="fontWeight"
            style="margin-top: 0px; font-size: 16px; font-weight: 800"
        >费率维护</span
        >
        <div>
          <div class="add-box clearfix">
            <vxe-table
                ref="xTable"
                class="table-style"
                show-overflow
                auto-resize
                :data="tableData"
                max-height="350"
                :edit-rules="formRules"
                :edit-config="{ trigger: 'click', mode: 'cell' }"
            >
              <vxe-table-column width="40" align="center">
                <template v-slot:header>
                  <Button
                      class="add-btn"
                      icon="md-add"
                      @click="insertEvent()"
                  ></Button>
                </template>
                <template v-slot="{ row, $rowIndex }">
                  <Button
                      class="del-btn"
                      icon="md-remove"
                      @click="removeEvent(row, $rowIndex)"
                  ></Button>
                </template>
              </vxe-table-column>
              <vxe-table-column title="关联公司" field="compId" min-width="180">
                <template v-slot:header>
                  <!-- <span
                    style="color: #f56c6c;
    margin-right: .2em;
    font-family: Verdana,Arial,Tahoma;"
                  >*</span> -->
                  <span>关联公司</span>
                </template>
                <template v-slot="{ row }">
                  <!--                  <Select v-model="row.compId" filterable @on-blur="clearTableV" transfer>-->
                  <!--                    <Option-->
                  <!--                        v-for="item in companyList"-->
                  <!--                        :value="item.value"-->
                  <!--                        :key="item.value"-->
                  <!--                    >{{ item.label }}-->
                  <!--                    </Option-->
                  <!--                    >-->
                  <!--                  </Select>-->
                  <vxe-select
                      v-model="row.compId"
                      placeholder="关联公司"
                      transfer
                  >
                    <vxe-option
                        v-for="item in companyList"
                        :value="item.value"
                        :key="item.value"
                        :label="item.label"
                    ></vxe-option>
                  </vxe-select>
                </template>
              </vxe-table-column>
              <vxe-table-column field="rateManage" title="管理费(%)">
                <template v-slot:header>
                  <span>管理费(%)</span>
                </template>
                <template v-slot="{ row }">
                  <vxe-input
                      v-model="row.rateManage"
                      placeholder="选填"
                  ></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="rateManage" title="实收管理费(%)">
                <template v-slot:header>
                  <span>实收管理费(%)</span>
                </template>
                <template v-slot="{ row }">
                  <vxe-input
                      v-model="row.realRateManage"
                      placeholder="选填"
                  ></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="rateInterest" title="利率(%)">
                <template v-slot="{ row }">
                  <vxe-input
                      v-model="row.rateInterest"
                      placeholder="选填"
                  ></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column field="rateDeduct" title="按价税合计抵扣 (%)">
                <template v-slot="{ row }">
                  <vxe-input
                      v-model="row.rateDeduct"
                      placeholder="选填"
                  ></vxe-input>
                </template>
              </vxe-table-column>
              <vxe-table-column
                  field="rateDeductManage"
                  title="按增值税税额抵扣(%)"
              >
                <template v-slot="{ row }">
                  <vxe-input
                      v-model="row.rateDeductManage"
                      placeholder="选填"
                  ></vxe-input>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </div>
        <div style="display: flex; ">
          <div class="add-box" style="display: inline-block;width: 50%">
            <vxe-table
                border
                show-overflow
                :auto-resize="true"
                class="table-upload-style"
                max-height="120"
                style="margin-bottom: 15px"
                :data="credData"
                :edit-config="{ trigger: 'click', mode: 'cell' }"
            >
              <vxe-table-column field="url" title="上传证件">
                <template v-slot="{ row }">
                  <upload-list
                      :isEdit="true"
                      :row="row"
                      :initFileList="credList"
                      :view="'arrange'"
                  ></upload-list>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
          <div class="add-box" style="display: inline-block;width: 50%">
            <vxe-table
                border
                show-overflow
                :auto-resize="true"
                class="table-upload-style"
                max-height="120"
                style="margin-bottom: 15px"
                :data="fileData"
                :edit-config="{ trigger: 'click', mode: 'cell' }"
            >
              <vxe-table-column field="url" title="上传附件">
                <template v-slot="{ row }">
                  <upload-list
                      :isEdit="true"
                      :row="row"
                      :initFileList="fileList"
                      :view="'arrange'"
                  ></upload-list>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </div>

        <div class="modal-footer add-btn-box">
          <!-- <Button status="primary" @click="createSalesmanModal=false">取 消</Button>
          <Button status="primary" @click="commit">确 定</Button>-->
          <vxe-form-item>
            <vxe-button
                status="primary"
                @click="createSalesmanModal = false"
                style="width: 140px; border-radius: 0px; margin-right: 10px"
            >取 消
            </vxe-button>
            <vxe-button
                type="submit"
                status="primary"
                style="width: 140px; border-radius: 0px"
            >确定
            </vxe-button>
          </vxe-form-item>
        </div>
      </vxe-form>
    </div>
    <vxe-modal
        v-model="isShowContract"
        title="关联合同"
        width="1400"
        height="600"
        resize
    >
      <choose-agreement
          @choose="chooseAgreement"
          ref="agreementModel"
          :isSalesMan="true"
      ></choose-agreement>
    </vxe-modal>
  </vxe-modal>
</template>

<script>
import $api from "@/apiProvider";
import {showLoading, hideLoading} from "@/utils/util";
import $C from "@/consts";
import UploadList from "@/components/common/UploadList";
import DetailModal from "@/views/logistics/DetailModal";
import ChooseLogistics from "@/components/modal/ChooseLogistics";
import ChooseOrderTwo from "@/components/modal/ChooseOrderTwo";
import PlatformCorp from "@/components/common/PlatformCorp";
import ChooseAgreement from "@/components/order2.0/Agreement/ChooseAgreement";

export default {
  components: {
    UploadList,
    ChooseAgreement
  },
  data() {
    return {
      isShowContract: false,
      credData: [
        {
          fileUuidList: []
        }
      ],
      fileData: [
        {
          fileUuidList: []
        }
      ],
      fileList: [],
      credList: [],
      modalTitle: "新增业务员管理",
      salesManId: null,
      isDdit: false,
      salesManagerId: null,
      clientManagerId: null,
      taxType: $C.TAX_TYPE.options, // 是否含税类型选择框
      tableData: [
        {
          rateDeduct: null,
          rateDeductManage: null,
          rateInterest: null,
          rateManage: null,
          realRateManage: null,
          compId: null,
          id: null
        }
      ],
      updateId: null,
      formData: {},
      modalType: null,
      createSalesmanModal: false,
      salesmanList: [],
      salesManageList: [],
      isSignList: [
        {
          value: 1,
          label: "是"
        },
        {
          value: 0,
          label: "否"
        }
      ],
      companyList: [],
      formRules: {
        salesManId: [{required: true, message: "请选择业务员"}]
      },
      contractNum: null,
      contractId: null,
      contractType: null,
      rateCps: null,
      rateCpsOutside: null
    };
  },
  mounted() {
    this.queryCompManage();
  },
  methods: {
    checkNum(e, filed) {
      this[filed] = e.match(/^\d*(\.?\d{0,2})/g)[0];
    },
    remove() {
      this.contractNum = null;
      this.contractId = null;
    },
    openContract() {
      this.isShowContract = true;
      this.$refs.agreementModel.init();
    },
    chooseAgreement(row, type) {
      this.isShowContract = false;
      if (type === 1) {
        this.contractNum = row.numb;
        this.contractId = row.id;
        if (row.contractType === 2) {
          this.contractType = 3;
        } else {
          this.contractType = 2;
        }
      } else {
        this.contractNum = row.contractNum;
        this.contractId = row.id;
        this.contractType = 1;
      }
    },
    editSalesman(row) {
      this.queryCompManage();
      this.querysalesMan();
      this.querysalesManage();
      this.modalTitle = "编辑业务员管理";
      this.modalType = 2;
      this.isDdit = true;
      (this.credList = []),
          (this.fileList = []),
          (this.credData = [
            {
              fileUuidList: []
            }
          ]),
          (this.fileData = [
            {
              fileUuidList: []
            }
          ]),
          this.getSalesmanDetail(row);
      this.createSalesmanModal = true;
    },
    reTemp() {
      this.rateCps = null;
      this.rateCpsOutside = null;
      this.contractNum = null;
      this.contractId = null;

      this.formData = {};
      this.tableData = [
        {
          rateDeduct: null,
          rateDeductManage: null,
          rateInterest: null,
          rateManage: null,
          realRateManage: null,
          compId: null,
          id: null
        }
      ];
    },
    close() {
      this.reTemp();
    },
    createSalesman() {
      this.queryCompManage();
      this.querysalesMan();
      this.querysalesManage();
      // this.queryCompanyPermission();
      this.modalType = 1;
      this.isDdit = false;
      (this.credList = []),
          (this.fileList = []),
          (this.credData = [
            {
              fileUuidList: []
            }
          ]),
          (this.fileData = [
            {
              fileUuidList: []
            }
          ]),
          (this.modalTitle = "新增业务员管理");
      this.reTemp();
      this.createSalesmanModal = true;
    },
    clearTableV() {
      this.$refs.xTable.clearValidate();
    },
    async commit() {
      var self = this;
      var tempCopy = {
        rateList: []
      };
      let sts = await this.validEvent();
      if (!sts) {
        this.$XModal.message({status: "error", message: "校验不通过！"});
        return;
      }
      showLoading();
      self.tableData.forEach(function (item, index) {
        let obj = {};
        obj.rateDeduct = item.rateDeduct;
        obj.rateDeductManage = item.rateDeductManage;
        obj.rateInterest = item.rateInterest;
        obj.rateManage = item.rateManage;
        obj.realRateManage = item.realRateManage;
        obj.compId = item.compId;
        obj.id = item.id;

        // if (self.modalType == 2) {
        //   tempCopy.id = self.updateId
        // }
        tempCopy.rateList.push(obj);
        console.log(tempCopy);
      });
      tempCopy.clientManagerId = self.formData.clientManagerId;
      tempCopy.salesManId = self.formData.salesManId;
      tempCopy.salesManagerId = self.formData.salesManagerId;
      tempCopy.salesManagerIdOutside = self.formData.salesManagerIdOutside;
      tempCopy.isSign = self.formData.isSign;
      tempCopy.credList = self.credData[0].fileUuidList;
      tempCopy.fileList = self.fileData[0].fileUuidList;
      tempCopy.contractId = self.contractId;
      tempCopy.contractNum = self.contractNum;
      tempCopy.contractType = self.contractType;
      tempCopy.isCps = Number(self.formData.isCps);
      tempCopy.rateCps = Number(this.rateCps);
      tempCopy.rateCpsOutside = Number(this.rateCpsOutside);
      tempCopy.cpsType = self.formData.cpsType;

      var url = "";
      if (this.modalType == 1) {
        url = "createSales";
      }
      if (this.modalType == 2) {
        url = "updateSales";
      }
      let res = await $api.baseUserSales.request(url, tempCopy);
      hideLoading();
      if (res.status == 1) {
        this.createSalesmanModal = false;
        this.reTemp();
        this.$emit("createCommit", true);
        if (this.modalType == 2) {
          this.$Message["success"]({
            background: true,
            content: "编辑成功"
          });
        } else {
          this.$Message["success"]({
            background: true,
            content: "创建成功"
          });
        }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    async insertEvent(row) {
      let record = {
        rateDeduct: null,
        rateDeductManage: null,
        rateInterest: null,
        rateManage: null,
        realRateManage: null,
        compId: null
      };
      let {row: newRow} = await this.$refs.xTable.insertAt(record, row);
      this.$refs.xTable.data.push(record);
      // await this.$refs.xTable.setActiveCell(newRow, "ordersBuyerId");
      console.log(this.$refs.xTable.getTableData().fullData);
    },
    async validEvent() {
      let errMap = await this.$refs.xTable.validate().catch(errMap => errMap);
      return errMap ? false : true;
    },
    async getSalesmanDetail(row) {
      let self = this;
      var data = {
        id: row.salesManId
      };
      let response = await $api.baseUserSales.request("querySalesDetail", data);
      if (response.status == 1) {
        let res = response.data;
        this.formData.clientManagerId = res.clientManagerId;
        this.formData.salesManagerId = res.salesManagerId;
        this.formData.salesManagerIdOutside = res.salesManagerIdOutside;
        this.formData.salesManId = res.salesManId;
        this.formData.isSign = res.isSign;
        this.formData.isCps = res.isCps == 1 ? "1" : "0";
        this.formData.cpsType = res.cpsType;
        this.rateCps = res.rateCps;
        this.rateCpsOutside = res.rateCpsOutside;
        this.tableData = res.rateList;
        this.updateId = res.id;
        this.contractId = res.contractId;
        this.contractNum = res.contractNum;

        if (res.credList != null) {
          res.credList.map(i => {
            self.credList.push(i);
          });
        }
        if (res.fileList != null) {
          res.fileList.map(i => {
            self.fileList.push(i);
          });
        }
        self.$forceUpdate();
      } else {
        this.$XModal.alert({
          message: response.message ? response.message : "接口异常",
          status: "error"
        });
      }
    },
    async queryCompanyPermission() {
      var self = this;
      let response = await $api.user.request("queryCompanyPermission");
      if (response.status == 1) {
        let res = response.data;
        res.forEach(function (item, index) {
          var obj = {};
          obj.value = item.companyID;
          obj.label = item.companyName;
          self.companyList.push(obj);
        });
      } else {
        this.$XModal.alert({
          message: response.message ? response.message : "接口异常",
          status: "error"
        });
      }
    },
    async querysalesMan() {
      var self = this;
      self.salesmanList = [];
      var data = {
        type: 1
      };
      let response = await $api.baseUserSales.request(
          "querySalesSelectQuick",
          data
      );
      if (response.status == 1) {
        let res = response.data;
        res.forEach(function (item, index) {
          var obj = {};
          obj.value = item.id;
          obj.label = item.text;
          self.salesmanList.push(obj);
        });
      } else {
        this.$XModal.alert({
          message: response.message ? response.message : "接口异常",
          status: "error"
        });
      }
    },
    async querysalesManage() {
      var self = this;
      self.salesManageList = [];
      var data = {
        type: 2
      };
      let response = await $api.baseUserSales.request(
          "querySalesSelectQuick",
          data
      );
      if (response.status == 1) {
        let res = response.data;
        res.forEach(function (item, index) {
          var obj = {};
          obj.value = item.id;
          obj.label = item.text;
          self.salesManageList.push(obj);
        });
      } else {
        this.$XModal.alert({
          message: response.message ? response.message : "接口异常",
          status: "error"
        });
      }
    },
    removeEvent(row, i) {
      if (this.$refs.xTable.getTableData().fullData.length > 1) {
        this.$refs.xTable.remove(row);
        this.$refs.xTable.data.splice(i, 1);
      }
    },
    async queryCompManage() {
      var self = this;
      self.companyList = [];
      var data = {
        type: 3
      };
      let response = await $api.baseUserSales.request(
          "querySalesSelectQuick",
          data
      );
      if (response.status == 1) {
        let res = response.data;
        res.forEach(function (item, index) {
          var obj = {};
          obj.value = item.id;
          obj.label = item.text;
          self.companyList.push(obj);
        });
      } else {
        this.$XModal.alert({
          message: response.message ? response.message : "接口异常",
          status: "error"
        });
      }
    }
  }
};
</script>
<style>
.vxe-cell .ivu-select {
  display: inline-block;
  width: 90%;
  box-sizing: border-box;
  vertical-align: middle;
  color: #515a6e;
  font-size: 14px;
  line-height: normal;
  margin: 10px 0px;

  margin-left: 10px;
}

.table-style .ivu-icon-ios-arrow-down {
  position: absolute;
  right: 10px;
  top: 50%;
  color: #999;
  cursor: pointer;
}

.modal-container {
  position: relative;
  height: 100%;
}

.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>
<style scoped>
/* .fontWeight{
  display: block;
  width: 100%;
  border: 1px solid #f00;
} */
</style>